$ = require('jquery')
scrollbarWidth = require('scrollbarWidth')


module.exports =
	init: (payload) ->
		{$target} = payload

		$target.find('.js-scroll-nav').each(->
			$list = $(this)
			$wrap = $list.parent()
			isInit = false
			scrollLeft = 0
			scrollWidth = $list.get(0).scrollWidth
			hasBackground = false

			arrowTpl = (direction) ->
				className = "scroll-nav scroll-nav--#{direction}"

				if hasBackground
					className = "#{className} scroll-nav--background"

				return "<a href='#' class='#{className}'><span class='icon icon-chevron-#{direction}'></span></a>"

			hasScrollbar = ->
				return Math.abs(scrollWidth - $list.innerWidth()) > 2

			init = ->
				isInit = true

				if $list.filter('.menu-secondary__list').length
					hasBackground = true

				addArrow('right')
				$list.css('marginBottom', - scrollbarWidth())

				$wrap
					.on('mousedown touchstart', '.scroll-nav', (event) ->
						event.preventDefault()

						if $(this).hasClass('scroll-nav--right')
							move('right')
						else if $(this).hasClass('scroll-nav--left')
							move('left')
					)
					.on('mouseup touchend', '.scroll-nav', ->
						$list.stop()
					)
					.on('click', '.scroll-nav', (event) ->
						event.preventDefault()
					)

				$list
					.on('scroll', ->
						handleScroll()
					)

				if $list.find('.menu-secondary__link.is-active').length

					$active = $list.find('.menu-secondary__link.is-active').parent()
					$closest = $active.closest('.menu-secondary__wrap')

					console.log('----')
					console.log($active)
					console.log($active.offset().left)
					console.log($active.outerWidth())
					console.log($list.width())
					console.log('----')

					if $active.offset().left + $active.outerWidth() > $list.width()
						$list.scrollLeft( $active.offset().left + $active.outerWidth() )
						$wrap.find('.scroll-nav--right').trigger('mousedown')

			recalculate = ->
				scrollWidth = $list.get(0).scrollWidth
				handleScroll()

			destroy = ->
				isInit = false
				scrollLeft = 0
				removeArrow('left')
				removeArrow('right')
				$list.css('marginBottom', '')

				$wrap
					.off('mousedown touchstart mouseup touchend', '.scroll-nav')

				$list
					.off('scroll')

			addArrow = (direction) ->
				$arrow = $wrap.find(".scroll-nav--#{direction}")

				if not $arrow.length
					$list
						.after(arrowTpl(direction))

			removeArrow = (direction) ->
				$arrow = $wrap.find(".scroll-nav--#{direction}")

				if $arrow.length
					$arrow.remove()

			handleScroll = ->
				scrollLeft = $list.scrollLeft()

				if scrollLeft >= 5
					addArrow('left')
				else
					removeArrow('left')

				if ((scrollWidth - $list.innerWidth()) - scrollLeft) <= 5
					removeArrow('right')
				else
					addArrow('right')

			handleResize = ->
				if hasScrollbar()
					if isInit
						recalculate()
					else
						init()
				else
					if isInit
						destroy()

			move = (direction) ->
				speed = 310 / 1000
				duration = 0
				distance = 0

				if direction is 'right'
					scroll = scrollWidth
					distance = (scrollWidth - $list.innerWidth())
				else if direction is 'left'
					scroll = 0
					distance = scrollLeft

				duration = distance / speed

				$list.stop().animate(
					scrollLeft: scroll
				, duration, 'linear')

			$(window)
				.on('resize', handleResize)

			if hasScrollbar()
				init()
		)



/** WEBPACK FOOTER **
 ** ./src/js/components/scrollNav.coffee
 **/